import { put, takeLatest, all, fork, join } from 'redux-saga/effects';
import { authenticationWrapper } from '@services/errorHandlingService';
import {
  TYPES,
  checkForExistingNameComplete,
  checkForExistingNameError,
} from './actions';
import {
  checkExistingEntityName,
  checkExistingMediaTitle,
  checkExistingMentorFormName,
} from './service';
import { RESOURCES } from '@shared/Resources/types';

export function* callCheckForExistingName(action) {
  yield authenticationWrapper(function* codeBlock() {
    try {
      const { type, name } = action.payload;
      let res;
      switch (type) {
        case RESOURCES.MEDIA:
          res = yield fork(checkExistingMediaTitle, name);
          break;
        case RESOURCES.MENTOR_FORM:
          res = yield fork(checkExistingMentorFormName, name);
          break;
        default:
          res = yield fork(checkExistingEntityName, type, name);
      }
      const result = yield join(res);
      yield put(checkForExistingNameComplete(result));
    } catch (error) {
      yield put(checkForExistingNameError(error.message));
    }
  });
}

function* watchCallCheckForExistingName() {
  yield takeLatest(TYPES.CHECK_FOR_EXISTING_NAME, callCheckForExistingName);
}

export default function* builderDataBuilderHeaderSaga() {
  yield all([fork(watchCallCheckForExistingName)]);
}
